import { TranslatePipe } from '@ngx-translate/core';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Transition } from '@uirouter/angular';

import { Universe, UniverseService } from '../../../../_services';
import { ToasterService } from '../../../_shared/toaster/toaster.service';

@Component({
    selector: 'universe-detail',
    templateUrl: './detail.component.html',
    styleUrls: ['./detail.component.scss'],
    providers: [TranslatePipe],
})
export class UniverseDetailComponent implements OnInit {
    @Input() universe: Universe;
    @Input() type: string;
    @Output() getUniverse: EventEmitter<any> = new EventEmitter<Universe>();

    universeId: string;
    universeName: string;
    usersNames: string[] = [];
    users: any;

    constructor(
        private universeService: UniverseService,
        private trans: Transition,
        private toasterService: ToasterService
    ) {}

    ngOnInit(): void {
        if (this.type !== 'create' && this.type !== 'createInModal') {
            this.type = 'update';
        }
        if (this.type === 'update') {
            this.universeId = this.trans.params()['id'];
            this.fetchUniverse(this.universeId);
        } else {
            this.universeName = null;
        }
    }

    fetchUniverse(id) {
        this.universeService.findById(id).subscribe((universe) => {
            this.universe = universe;
            this.universeName = universe.name;
        });
    }

    save(): void {
        const universe = JSON.parse(JSON.stringify(this.universe));

        if (this.type === 'createInModal') {
            this.universeService.update(universe).subscribe(
                (response) => {
                    if (response !== null) {
                        this.getUniverse.emit(response);
                    }
                },
                (error) => {
                    this.toasterService.error();
                }
            );
        } else if (this.type !== 'create') {
            this.universeService.update(universe).subscribe(
                (response) => {
                    if (response !== null) {
                        this.getUniverse.emit(response);
                        this.isSuccessful();
                    }
                },
                (error) => {
                    this.toasterService.error();
                }
            );
        } else {
            this.universeService.create(universe).subscribe(
                (response) => {
                    if (response !== null) {
                        this.isSuccessful(response.id);
                    }
                },
                (error) => {
                    this.toasterService.error();
                }
            );
        }
    }

    removeUniverse(universe: Universe) {
        universe.deleted = true;
        this.universeService.remove(universe).subscribe();
    }

    private isSuccessful(id?: number) {
        this.toasterService.success();
        window.setTimeout(() => {
            window.scrollTo(0, document.body.scrollHeight);
        }, 0);
        window.setTimeout(() => {
            if (typeof id !== 'undefined') {
                window.location.href = '#/universes/' + id;
            } else {
                window.location.href = '#/universes';
            }
        }, 1542);
    }

    myListFormatter(data: any): string {
        let html = '';
        html += data.name ? `<span><strong>${data.name}</strong></span>` : '';

        return html;
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/directory/universe/detail/detail.component.ts